export default {
  borderTop: (color: string): string => `8px solid ${color}`
};
